export enum SceneTypes {
  Main = 1,
  Detail = 2
};

export enum Lang {
  bg = 1,
  en = 2
}

export enum MainSceneInfoPanel {
  TotalBuildingConsumption = 1,
  EnergyDistribution = 2,
  WeatherStation = 3,
  Common = 4
}

export enum TagType {
  Еlectricity = 1,
  Water = 2,
  Air = 3,
  Gas = 4,
  Compressor = 5,
  Production = 6,
  Lighting = 7,
  Machines = 8,
  Administration = 9,
  DayWithoutAccidents = 10,
  VisitorsMonth = 11,
  VisitorsYear = 12,
  Alarms = 13,
  InternalTemperature = 14,
  OutsideTemperature = 15,
  WindSpeed = 16,
  Humidity = 17
}

export enum Months {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12
}

